import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Fullscreen = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M3.213 2.535c-.613 0-1.118.504-1.118 1.129V16.06c0 .584-.469 1.057-1.047 1.057A1.053 1.053 0 0 1 0 16.06V3.664C0 1.862 1.451.42 3.213.42H15.49c.578 0 1.047.473 1.047 1.058 0 .584-.469 1.057-1.047 1.057H3.213ZM27.462 1.478c0-.585.469-1.058 1.047-1.058h12.278C42.572.42 44 1.885 44 3.664V16.06c0 .584-.469 1.057-1.048 1.057a1.053 1.053 0 0 1-1.047-1.057V3.664c0-.62-.5-1.129-1.118-1.129H28.51a1.053 1.053 0 0 1-1.047-1.057ZM42.952 27.723c.579 0 1.048.473 1.048 1.057v12.396c0 1.802-1.451 3.244-3.213 3.244H28.51a1.053 1.053 0 0 1-1.047-1.058c0-.584.469-1.058 1.047-1.058h12.278c.613 0 1.118-.503 1.118-1.128V28.78c0-.584.469-1.058 1.047-1.058ZM1.048 27.723c.578 0 1.047.473 1.047 1.057v12.396c0 .615.509 1.128 1.118 1.128H15.49c.578 0 1.047.474 1.047 1.058 0 .584-.469 1.058-1.047 1.058H3.213C1.447 44.42 0 42.96 0 41.176V28.78c0-.584.469-1.058 1.048-1.058Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
Fullscreen.displayName = 'Fullscreen';
Fullscreen.defaultProps = {
  'aria-label': 'Fullscreen'
};
export default Fullscreen;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Fullscreen.js
// module id = 3801
// module chunks = 11